export var SDK_NAME = 'sentry.javascript.browser';
export var SDK_VERSION = '5.21.4';
//# sourceMappingURL=version.js.map